import { isClient } from '@/components/base/utils';

import { i18n, type Locale } from '@/lib/i18n-config';

// 지원하는 로케일 목록
const SUPPORTED_LOCALES = i18n.locales;
const DEFAULT_LOCALE = i18n.defaultLocale;

// 클라이언트 사이드에서 사용
export function determineLocaleClient(): Locale {
	// 1. 저장된 사용자 선호 로케일 확인 (예: localStorage)
	const savedLocale = localStorage.getItem('preferredLocale') as Locale;
	if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale as (typeof SUPPORTED_LOCALES)[number])) {
		return savedLocale;
	}

	// 2. 브라우저의 언어 설정 확인
	// @ts-ignore
	const browserLocales = navigator.languages || [navigator.language || navigator.userLanguage];

	for (let locale of browserLocales) {
		locale = locale.split('-')[0]; // 'en-US'와 같은 형식에서 'en'만 추출
		if (SUPPORTED_LOCALES.includes(locale as (typeof SUPPORTED_LOCALES)[number])) {
			return locale as Locale;
		}
	}

	// 3. 기본 로케일 반환
	return DEFAULT_LOCALE;
}

// 공통 함수 (클라이언트와 서버 모두에서 사용 가능)
export function determineLocale(): Locale {
	if (isClient) {
		// 클라이언트 사이드
		return determineLocaleClient();
	}
	// 기본값
	return DEFAULT_LOCALE;
}
